import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-wmax",
  "use": "icon-wmax-usage",
  "viewBox": "0 0 1027 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1027 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-wmax\"><defs><style></style></defs><path d=\"M971.811.341a55.26 55.26 0 0 1 55.26 55.26v426.382a55.43 55.43 0 0 1-110.86 0V55.6l55.259 55.26H538.436a55.43 55.43 0 1 1 0-110.86zM55.43 1023.66a55.26 55.26 0 0 1-55.26-55.26V542.018a55.43 55.43 0 1 1 110.86 0V968.4l-55.259-55.26h433.375a55.43 55.43 0 0 1 0 110.86z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol